import React from 'react'
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom'
import {
  AUTHENTICATED_ENTRY,
  AUTH_PREFIX_PATH,
  REDIRECT_COMPONENT_KEY,
} from 'configs/AppConfig'
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig'
import ProtectedRoute from './ProtectedRoute'
import PublicRoute from './PublicRoute'
import AppRoute from './AppRoute'
import AppLayoutOutlet from 'layouts/AppLayoutOutlet'
import AuthLayoutOutlet from 'layouts/AuthLayoutOutlet'
import { useSelector } from 'react-redux'
import {
  EMPLOYER_TYPE,
  BRANCH_ALLOWED_ROUTE_KEYS,
  isBranchUserType,
} from 'constants/AuthConstant'

const canAccessRoute = (route, type) => {
  if (route.key === REDIRECT_COMPONENT_KEY) {
    return true
  }
  if (isBranchUserType(type)) {
    return BRANCH_ALLOWED_ROUTE_KEYS.includes(route.key)
  }
  if (type === EMPLOYER_TYPE) {
    return true
  }
  return Boolean(route.isPage)
}

const Routes = () => {
  const { type } = useSelector((state) => state.auth)

  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route element={<AppLayoutOutlet />}>
          <Route path="/" element={<Navigate replace to={AUTHENTICATED_ENTRY} />} />
          {protectedRoutes.map((route, index) => {
            if (!canAccessRoute(route, type)) {
              return null
            }
            return (
              <Route
                key={`${route.key}-${index}`}
                path={route.path}
                element={
                  <AppRoute
                    routeKey={route.key}
                    component={route.component}
                    {...(route.meta || {})}
                  />
                }
              />
            )
          })}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
      <Route path="/" element={<PublicRoute />}>
        <Route element={<AuthLayoutOutlet />}>
          {publicRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute routeKey={route.key} component={route.component} />
              }
            />
          ))}
          <Route
            path={AUTH_PREFIX_PATH}
            element={<Navigate to={`${AUTH_PREFIX_PATH}/login`} replace />}
          />
        </Route>
      </Route>
    </RouterRoutes>
  )
}

export default Routes
